"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useWaveDropsLeaderboard, WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { LeadingCard } from "./LeadingCard";
import { NextMintCard } from "./NextMintCard";
export function NextMintLeadingSection() {
  const $ = _c(38);
  const {
    seizeSettings,
    isLoaded
  } = useSeizeSettings();
  const waveId = seizeSettings.memes_wave_id;
  const t0 = waveId ?? "";
  const t1 = !!waveId;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      waveId: t0,
      enabled: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    decisionPoints,
    isFetching: isWinnersFetching
  } = useWaveDecisions(t2);
  const t3 = waveId ?? "";
  const t4 = !waveId;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      waveId: t3,
      sort: WaveDropsLeaderboardSort.RATING_PREDICTION,
      pausePolling: t4
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    drops,
    isFetching: isLeaderboardFetching
  } = useWaveDropsLeaderboard(t5);
  const latestDecision = decisionPoints[decisionPoints.length - 1];
  const nextMint = latestDecision?.winners[0]?.drop ?? null;
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== drops || $[7] !== isLeaderboardFetching || $[8] !== isLoaded || $[9] !== isWinnersFetching || $[10] !== nextMint || $[11] !== waveId) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const leading = drops.slice(0, 2);
      const isFetching = isWinnersFetching || isLeaderboardFetching;
      if (!isLoaded || !waveId) {
        t11 = null;
        break bb0;
      }
      let t12;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <div><span className="tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-white md:tw-text-2xl">Coming up</span><p className="tw-mb-0 tw-mt-2 tw-text-base tw-text-iron-500">Next in queue and current vote leaders</p></div>;
        $[18] = t12;
      } else {
        t12 = $[18];
      }
      const t13 = `/waves?wave=${waveId}`;
      let t14;
      let t15;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = <span>View all</span>;
        t15 = <ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" aria-hidden={true} />;
        $[19] = t14;
        $[20] = t15;
      } else {
        t14 = $[19];
        t15 = $[20];
      }
      let t16;
      if ($[21] !== t13) {
        t16 = <div className="tw-mb-8 tw-flex tw-flex-col tw-items-start tw-gap-4 sm:tw-flex-row sm:tw-items-end sm:tw-justify-between">{t12}<Link href={t13} className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-400 tw-no-underline tw-transition-colors hover:tw-text-white">{t14}{t15}</Link></div>;
        $[21] = t13;
        $[22] = t16;
      } else {
        t16 = $[22];
      }
      const header = t16;
      if (isFetching && !nextMint && leading.length === 0) {
        let t17;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
          t17 = <div className="tw-flex tw-h-64 tw-items-center tw-justify-center"><div className="tw-text-sm tw-text-white/40">Loading...</div></div>;
          $[23] = t17;
        } else {
          t17 = $[23];
        }
        let t18;
        if ($[24] !== header) {
          t18 = <section className="tw-px-4 md:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-@container tw-pb-10 md:tw-pb-16"><div>{header}{t17}</div></section>;
          $[24] = header;
          $[25] = t18;
        } else {
          t18 = $[25];
        }
        t11 = t18;
        break bb0;
      }
      if (!nextMint && leading.length === 0) {
        t11 = null;
        break bb0;
      }
      t10 = "tw-px-4 md:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-@container tw-pb-10 md:tw-pb-16";
      t9 = header;
      t6 = "tw-grid tw-grid-cols-1 tw-gap-6 lg:tw-grid-cols-3 lg:tw-gap-8";
      if ($[26] !== nextMint) {
        t7 = nextMint && <NextMintCard drop={nextMint} />;
        $[26] = nextMint;
        $[27] = t7;
      } else {
        t7 = $[27];
      }
      t8 = leading.map(_temp);
    }
    $[6] = drops;
    $[7] = isLeaderboardFetching;
    $[8] = isLoaded;
    $[9] = isWinnersFetching;
    $[10] = nextMint;
    $[11] = waveId;
    $[12] = t10;
    $[13] = t11;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[12];
    t11 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
    t12 = <div className={t6}>{t7}{t8}</div>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t9) {
    t13 = <div>{t9}{t12}</div>;
    $[32] = t12;
    $[33] = t9;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t13) {
    t14 = <section className={t10}>{t13}</section>;
    $[35] = t10;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}
function _temp(drop, index) {
  return <LeadingCard key={drop.id} drop={drop} rank={index + 1} />;
}